/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataSourceInformation } from '../models/DataSourceInformation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DataSourceIntegrationsService {
    /**
     * Get Available Data Sources
     * @returns DataSourceInformation Successful Response
     * @throws ApiError
     */
    public static getAvailableDataSourcesApiV1DataSourceAvailableGet({
        excludeConnected = true,
        xTransactionId,
    }: {
        excludeConnected?: boolean,
        xTransactionId?: (string | null),
    }): CancelablePromise<Array<DataSourceInformation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/data_source/available',
            headers: {
                'x-transaction-id': xTransactionId,
            },
            query: {
                'exclude_connected': excludeConnected,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
